interface AvailabilityScope {
  category?: string;
  chain?: string;
  storeIds?: string[];
  clusterIds?: string[];
  geo?: string;
}

export type PogSizeQueryParams = AvailabilityScope;

export interface PeriodQueryParams extends AvailabilityScope {
  timeframe: string;
  pogSizes?: number[];
}

export const MICROSPACE_QUERY_KEY = ["microspace-analysis"] as const;

export const microspaceQueryKeys = {
  all: MICROSPACE_QUERY_KEY,
  analysis: () => [...MICROSPACE_QUERY_KEY, "analysis"] as const,
  metadata: () => [...MICROSPACE_QUERY_KEY, "metadata"] as const,
  filters: () => [...MICROSPACE_QUERY_KEY, "metadata", "filters"] as const,
  savedConfigs: () => [...MICROSPACE_QUERY_KEY, "metadata", "saved-configs"] as const,
  categoryClusters: () => [...MICROSPACE_QUERY_KEY, "metadata", "category-clusters"] as const,
  categoryClustersForChain: (chain: string) =>
    [...MICROSPACE_QUERY_KEY, "metadata", "category-clusters", { chain }] as const,
  availablePogSizes: (params: PogSizeQueryParams) =>
    [...MICROSPACE_QUERY_KEY, "metadata", "available-pog-sizes", params] as const,
  availablePeriods: (params: PeriodQueryParams) =>
    [...MICROSPACE_QUERY_KEY, "metadata", "available-periods", params] as const,
  storePogSizes: (category: string, chain?: string) =>
    [...MICROSPACE_QUERY_KEY, "metadata", "store-pog-sizes", { category, chain }] as const,
};
